module.exports = __webpack_public_path__ + "img/200-Gris Quartz Structuré.jpg";